
import { Navigate, useLocation } from 'react-router-dom';
import { PUBLIC_PATHS } from 'routes/constants';

export const RequireInviteKey = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userKey = params.get('user-key');

  if (!userKey) {
    return <Navigate to={PUBLIC_PATHS.LOGIN} replace />;
  }

  return <>{children}</>;
};